import { jsx as n } from "react/jsx-runtime";
import { c as p } from "../index-rKuIKazb.js";
import { useTheme as f } from "../ThemeProvider/index.js";
import '../assets/index20.css';const y = "_layout_tk24l_2", g = "_bold_tk24l_11", N = "_disabled_tk24l_15", x = "_dark_tk24l_19", a = {
  layout: y,
  "--theme-primary": "_--theme-primary_tk24l_7",
  bold: g,
  disabled: N,
  dark: x
}, C = (u) => {
  const {
    bold: i,
    className: b,
    children: t,
    CustomLink: e,
    dataAaa: s,
    dataProductSlug: l,
    disabled: k,
    href: o,
    rel: d,
    target: r,
    theme: c,
    to: m
  } = u, h = f(), _ = p(
    a[h],
    a.layout,
    i && a.bold,
    c && a[`--theme-${c}`],
    k && a.disabled,
    b
  );
  return e ? /* @__PURE__ */ n(
    e,
    {
      className: _,
      "data-aaa": s,
      "data-product-slug": l,
      href: o || m,
      rel: d,
      target: r,
      to: m,
      children: t
    }
  ) : /* @__PURE__ */ n(
    "a",
    {
      className: _,
      "data-aaa": s,
      "data-product-slug": l,
      href: o,
      rel: d,
      target: r,
      children: t
    }
  );
};
export {
  C as default
};
